import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import PartsAuthoritySettingsHtml from './parts-authority.settings.html';

export function PartsAuthorityStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'PartsAuthoritySettingsCtrl',
    name       : 'app.parts-authority-settings',
    templateUrl: PartsAuthoritySettingsHtml,
    url        : '/parts-authority-settings',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      session     : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  });
}
